import orderServices from "../services/orderServices";
import { clearCart } from "../slices/cartSlice";

export const ORDER_CREATE_REQUEST = "ORDER_CREATE_REQUEST";
export const ORDER_CREATE_SUCCESS = "ORDER_CREATE_SUCCESS";
export const ORDER_CREATE_FAIL = "ORDER_CREATE_FAIL";

export const createOrder = (orderData) => async (dispatch) => {
  try {
    dispatch({ type: ORDER_CREATE_REQUEST });

    const { data } = await orderServices.createOrder(orderData);

    dispatch({
      type: ORDER_CREATE_SUCCESS,
      payload: data,
    });
    // 👉 CHECK SUCCESS RESPONSE (000)
    if (data?.paymentStatus === "Paid" || data?.code === "000") {
      dispatch(clearCart());
    }

  } catch (err) {
    dispatch({
      type: ORDER_CREATE_FAIL,
      payload: err.response?.data?.message || err.message,
    });
  }
};
